import styled from "@emotion/styled";

import PrintErrorLogImage from "./PrintErrorLog.png";

export const PrintErrorLogImageContainer = styled.div({
    marginTop: 20,
    marginBottom: 40,
    width: 400,
    height: 130,
    backgroundSize: "cover",
    backgroundImage: `url(${PrintErrorLogImage})`,
});
